import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography, Button, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    padding: 20,
    borderRadius: 6,
    border: '1px solid var(--color-warning-200, #fed7aa)',
    background: 'var(--color-warning-050, #fff7ed)',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  title: {
    fontSize: 14,
    fontWeight: 'var(--font-weight-semibold, 600)',
    color: 'var(--color-warning-800, #9a3412)'
  },
  body: {
    fontSize: 13,
    color: 'var(--color-warning-900, #7c2d12)',
    lineHeight: 1.5
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  }
}))

export default function StuckView ({ status, threadStatus, onContinue, isContinuing }) {
  const classes = useStyles()

  const message = describe({ status, threadStatus })

  return (
    <div className={classes.root}>
      <Typography component='div' className={classes.title}>The agent stopped before reaching a conclusion</Typography>
      <Typography component='div' className={classes.body}>{message}</Typography>
      <div className={classes.actions}>
        <Button
          variant='contained'
          color='primary'
          size='small'
          onClick={onContinue}
          disabled={isContinuing}
          startIcon={isContinuing ? <CircularProgress size={14} /> : null}
        >
          {isContinuing ? 'Restarting…' : 'Keep trying'}
        </Button>
      </div>
    </div>
  )
}

StuckView.propTypes = {
  status: PropTypes.string,
  threadStatus: PropTypes.string,
  onContinue: PropTypes.func,
  isContinuing: PropTypes.bool
}

function describe ({ status, threadStatus }) {
  if (status === 'aborted') {
    return 'The agent stopped before reaching a verdict. See the answer above for what blocked it; you can ask it to keep going from where it left off.'
  }
  if (threadStatus === 'cancelled') {
    return 'The investigation was cancelled. You can resume from where the agent stopped.'
  }
  return 'The agent ran out of room to keep investigating. Click "Keep trying" to give it more turns to complete the analysis.'
}
